<template>
    <div id="fabric-js-container" ref="fabricJSContainer">
        <canvas id="fabric-js-canvas" class="workspace-module-container" ref="fabricJS"></canvas>
    </div>
</template>

<script>
    import {urlForFileStorage} from "../common";
    import {fabricEditor} from "../../fabric/fabricMain";
    import store from "../../store";

    export default {
        name: "WorkspaceFabric.vue",
        mixins: [urlForFileStorage],
        async mounted() {
            if (!this.$store.getters[`projectList/${this.$route.params.projectUUID}/photoList/${this.$route.params.photoID}/planeList/PLANE_EXIST_BY_ID`](this.$route.params.planeID)) {
                this.$router.replace({
                    name: "planeCategories"
                }).catch(() => {
                })
                return
            }
            this.editor = new fabricEditor(this.$refs["fabricJS"]);
            this.editor.updateCanvaSize({
                    width: this.$refs["fabricJSContainer"].offsetWidth,
                    height: this.$refs["fabricJSContainer"].offsetHeight
                }
            )
            let source = await this.editor.addSourceImage(this.activePhotoAbsoluteURL);
            this.editor.addSetPerspective();
            this.editor.setViewport(source, 1);
        },
        destroyed() {
            if (this.editor)
                this.editor.destroy();
        },
        computed: {
            activePhotoAbsoluteURL() {
                return this.urlForFileStorage(this.$store.getters[`active/GET_ACTIVE_PHOTO`].src);
            }
        },
        methods: {


        }
    }
</script>

<style scoped>
    #fabric-js-container {
        width: 100%;
        height: 100%;
    }
</style>
